// Dependencies
import { FC } from "react";

// Components
import { StyledLink } from "./AuthLink.styled";

interface AuthLinkProps {
  href: string;
  children: string;
}

const AuthLink: FC<AuthLinkProps> = ({ href, children }) => {
  return (
    <StyledLink href={href} variant={"body1"}>
      {children}
    </StyledLink>
  );
};

export default AuthLink;
